import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { IllustrativeIcon, Txt } from '@vst/beam';
import { WhatToExpect } from '@vst/beam-icons/illustrative-icons';
import { useTranslation } from 'react-i18next';

import { CustomDecorativeModal } from '@app/components/Modal';
import { useScreenResolution } from '@app/hooks';
import { setIsCheckout, setSelectedProduct } from '@app/redux';

import { ErrorEnum } from '../utils/types';

type CheckoutErrorProps = {
  isModalOpen: boolean;
  handleClose: (isSuccess: boolean, error?: ErrorEnum) => void;
};

const CheckoutError = (props: CheckoutErrorProps): JSX.Element => {
  const { handleClose, isModalOpen } = props;
  const { t } = useTranslation('BuyMore');

  const dispatch = useDispatch();

  const { isSmall, isExtraSmall } = useScreenResolution();
  const isMobile = isSmall || isExtraSmall;

  const handleModalClose = useCallback(() => {
    handleClose(false, ErrorEnum.PURCHASE_ERROR);
  }, [handleClose]);

  const handleGoBack = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    dispatch(setIsCheckout(null));
    dispatch(setSelectedProduct(null));
  };

  return (
    <CustomDecorativeModal
      header={t('Global.error.title')}
      isOpen={isModalOpen}
      data-cy="outcome-buy-more-checkout-error"
      actions={{
        primary: { label: '', style: { display: 'none' } },
        secondary: {
          label: t('Checkout.error.buttons.goBack'),
          onClick: handleGoBack,
          'data-cy': 'buy-more-go-back',
        },
      }}
      onClose={handleModalClose}
      icon={<IllustrativeIcon icon={WhatToExpect} color="teal_600" />}
    >
      <Txt color="subtle" variant={isMobile ? 'bodySmallRegular' : 'bodyLargeRegular'}>
        {t('Browse.error.description')}
      </Txt>
    </CustomDecorativeModal>
  );
};

export default CheckoutError;
